
import { confirm_card_record_time_alert } from '@/api/mjstore-model';
import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import modalBox from '@/components/form-modal/modal-tools';
export default defineComponent({
  name: 'TipsModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any) {
    const store = useStore();
    const current_org = computed(() => store.getters['user/current_org']);
    const current_shop = computed(() => store.getters['user/current_shop']);
    const visible = ref<boolean>(true);
    const search = reactive({
      current: 1,
      pageSize: 1000,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.value.id,
        is_active: true,
      },
    });
    const confirm = (data: any) => {
      confirm_card_record_time_alert({
        org_id: current_org.value?.id,
        card_record_time_alert_id: data.id,
        shop_id: current_shop.value?.id,
      });
      const editModal = reactive({
        visible: true,
        component: 'TablePageModal2',
        obj: {
          title: '近三天到期时间卡',
          search: {
            ...search,
            requestParams: { ...search.requestParams, card_record_time_alert_id: data.id },
          },
          modalType: 'mjstore-tips',
        },
      });
      modalBox(editModal);
    };
    const onClose = () => {
      visible.value = false;
    };
    return {
      visible,
      confirm,
      onClose,
    };
  },
});
